
import { CheckCircle, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CompanyRequest } from "@/lib/types";

interface PendingRequestActionsProps {
  request: CompanyRequest;
  onApprove: (request: CompanyRequest) => void;
  onReject: (request: CompanyRequest) => void;
}

const PendingRequestActions = ({ request, onApprove, onReject }: PendingRequestActionsProps) => {
  return (
    <div className="flex justify-end gap-2">
      <Button
        size="sm"
        variant="outline"
        className="border-green-500 text-green-600 hover:bg-green-50"
        onClick={() => onApprove(request)}
      >
        <CheckCircle className="w-4 h-4 mr-1" />
        Approve
      </Button>
      <Button
        size="sm"
        variant="outline"
        className="border-red-500 text-red-600 hover:bg-red-50"
        onClick={() => onReject(request)}
      >
        <XCircle className="w-4 h-4 mr-1" />
        Reject
      </Button>
    </div>
  );
};

export default PendingRequestActions;
